import LiveCommentsFloatingWidget from "@/components/facebook/LiveCommentsFloatingWidget";
import ChatFloatingWidget from "@/components/chat/ChatFloatingWidget";
import { useChat } from "@/contexts/ChatContext";

type SaleFloatingWidgetsProps = {
  showingMessagingFloat: boolean;
  showingCommentsFloat: boolean;
  comments: any[];
  fetchCommentState: "idle" | "loading" | "success" | "error";
  showingComment: boolean;
  setShowingComment: (open: boolean) => void;
  showingChatMessage: boolean;
  setShowingChatMessage: (open: boolean) => void;
  onLoadingMoreComment?: () => void;
  isLoadingMoreComment?: boolean;
};

export function SaleFloatingWidgets({
  showingMessagingFloat,
  showingCommentsFloat,
  comments,
  fetchCommentState,
  showingComment,
  setShowingComment,
  showingChatMessage,
  setShowingChatMessage,
  onLoadingMoreComment,
  isLoadingMoreComment = false,
}: SaleFloatingWidgetsProps) {
  const {
    currentConversation,
    messages,
    isLoadingMessage,
    messageAfterCursor,
  } = useChat();

  return (
    <>
      {showingCommentsFloat && (
        <LiveCommentsFloatingWidget
          comments={comments}
          isLoading={fetchCommentState === "loading"}
          title="Comments"
          initialSize="md"
          open={showingComment}
          onOpenChange={setShowingComment}
          loadMore={isLoadingMoreComment}
          onRefresh={onLoadingMoreComment}
        />
      )}
      {showingMessagingFloat && (
        <ChatFloatingWidget
          currentConversation={currentConversation}
          messages={messages}
          isLoadingMessage={isLoadingMessage}
          prevCursor={messageAfterCursor!}
          open={showingChatMessage}
          onOpenChange={setShowingChatMessage}
        />
      )}
    </>
  );
}
